import { Box } from "@mui/material";
import { useTranslation } from "../../i18n/LanguageContext";
import { resolveCurrentStep } from "./StatusTimeline";

// 1-3 plain bullet points describing the resolved current step only —
// looked up by step_key from the i18n dictionary, never hardcoded per-component.
function StatusTimelineNotes({ timeline }) {
  const { t } = useTranslation();
  const currentStep = resolveCurrentStep(timeline);
  const bullets = currentStep ? t(`portal.statusTimeline.steps.${currentStep.step_key}.bullets`) : null;
  if (!Array.isArray(bullets) || bullets.length === 0) return null;

  return (
    <Box
      component="ul"
      sx={{
        m: 0,
        mt: 1,
        pl: 2.5,
        "& li": { fontSize: "0.8125rem", color: "#4b5563", mb: 0.25 },
      }}
    >
      {bullets.map((bullet) => (
        <li key={bullet}>{bullet}</li>
      ))}
    </Box>
  );
}

export default StatusTimelineNotes;
